import React from 'react';

const PdfVencimiento = ({ fecha }) => {
    const formatFecha = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    return (
        <div className="pdf-vencimiento-box">
            Vencimento Pronto Pago: {formatFecha(fecha)}
        </div>
    );
};

export default PdfVencimiento;
